// ===== LAW / DESIGN / MEDIA / HUMANITIES =====
const LAW_DESIGN_MEDIA = [
  {
    id: "law-5yr",
    name: "B.A. LL.B – Bachelor of Arts + Bachelor of Legislative Law (5-Year Integrated)",
    stream: "arts",
    category: "law-design-media",
    summary:
      "Integrated law course covering legal theory, constitutional law, civil/criminal law, and advocacy.",
    eligibility: "10+2 in any stream; minimum 45–50% marks. Entrance via CLAT, LSAT India, AILET, or state law entrances.",
    exams: ["CLAT", "AILET", "LSAT India", "DU LLB Entrance", "State Law CETs"],
    colleges: [
      "National Law School of India University (NLSIU), Bangalore",
      "NALSAR University, Hyderabad",
      "NLU Delhi",
      "Gujarat National Law University (GNLU), Gandhinagar",
      "Jamia Millia Islamia, New Delhi"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["law", "legal studies", "advocacy", "constitutional law"],
  },
  {
    id: "bfa-design",
    name: "B.F.A – Bachelor of Fine Arts / Design",
    stream: "arts",
    category: "law-design-media",
    summary:
      "Creative studies in fine arts, applied arts, fashion, product, communication, or interior design.",
    eligibility: "10+2 in any stream; entrance via NID/UCEED/NIFT/Institute-specific tests.",
    exams: ["NID Entrance", "UCEED", "NIFT Entrance", "State Design Exams"],
    colleges: [
      "National Institute of Design (NID), Ahmedabad",
      "Indian Institute of Art & Design (IIAD), Delhi",
      "MIT Institute of Design, Pune",
      "National Institute of Fashion Technology (NIFT), Mumbai/Delhi",
      "Pearl Academy, Delhi/Bangalore"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["design", "fine arts", "fashion", "product", "visual communication"],
  },
  {
    id: "mass-comm",
    name: "B.A. in Mass Communication / Journalism / Public Relations",
    stream: "arts",
    category: "law-design-media",
    summary:
      "Media studies: journalism, reporting, editing, advertising, PR, TV/radio/digital production.",
    eligibility: "10+2 in any stream; CUET UG or institute-specific entrance exams.",
    exams: ["CUET UG", "IPU CET", "State UG Entrance Exams"],
    colleges: [
      "Indian Institute of Mass Communication (IIMC), Delhi",
      "Xavier Institute of Communication (XIC), Mumbai",
      "Christ University, Bengaluru",
      "Symbiosis Institute of Media & Communication (SIMC), Pune",
      "Jamia Millia Islamia, New Delhi"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["journalism", "media", "PR", "advertising", "broadcast"],
  },
  {
    id: "bfa-visual-arts",
    name: "B.F.A – Bachelor of Visual Arts / Animation / Multimedia",
    stream: "arts",
    category: "law-design-media",
    summary:
      "Creative programs in animation, multimedia, 3D design, film-making, and visual communication.",
    eligibility: "10+2 in any stream; entrance via NID, NIFT, or institute-specific exams.",
    exams: ["NID Entrance", "NIFT Entrance", "UCEED", "State Design Exams"],
    colleges: [
      "National Institute of Design (NID), Ahmedabad",
      "MIT World Peace University, Pune",
      "Pearl Academy, Delhi",
      "Whistling Woods International, Mumbai"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["animation", "multimedia", "visual arts", "film-making", "3D design"],
  },
  {
    id: "bfa-fashion",
    name: "B.Des – Bachelor of Design (Fashion/Textile/Product/Interior)",
    stream: "arts",
    category: "law-design-media",
    summary:
      "Creative and technical studies in design fields: fashion, textiles, product, interior, or UX/UI design.",
    eligibility: "10+2 in any stream; NID, NIFT, UCEED, or institute-specific exams.",
    exams: ["NIFT Entrance", "NID Entrance", "UCEED", "State Design Exams"],
    colleges: [
      "NIFT Delhi/Mumbai/Chennai",
      "National Institute of Design (NID), Ahmedabad",
      "Pearl Academy, Delhi/Bangalore",
      "MIT Institute of Design, Pune"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["fashion", "textile", "interior", "product design", "UX/UI"],
  },
  {
    id: "ba-psychology",
    name: "B.A. Psychology / Sociology / Humanities",
    stream: "arts",
    category: "law-design-media",
    summary:
      "Human behavior, social sciences, research, counseling, and applied psychology for diverse careers.",
    eligibility: "10+2 in any stream; CUET UG or institute-specific exams.",
    exams: ["CUET UG", "State CETs"],
    colleges: [
      "Lady Shri Ram College (DU), Delhi",
      "St. Xavier's College, Mumbai",
      "Christ University, Bengaluru",
      "Hansraj College (DU), Delhi"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["psychology", "sociology", "humanities", "research", "counseling"],
  },
];

export default LAW_DESIGN_MEDIA;
